import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';
import { StaticPathPipe } from '../pipes/static-path.pipe';


/**
 * The point of this directive is to add in a loading gif to images while we're waiting for the content to load
 * The gif is removed when the image has finished loading its content
 */
@Directive({
  selector: '[appImgLoader]'
})
export class ImgLoaderDirective implements OnInit {

  // TODO: maybe pass in the fallback URL here as an input

  static loaderGifUrl: string;

  constructor(private renderer: Renderer2, private el: ElementRef, private staticPathPipe: StaticPathPipe) {}

  ngOnInit() {
    if (!ImgLoaderDirective.loaderGifUrl) ImgLoaderDirective.loaderGifUrl = this.staticPathPipe.transform('/assets/gifs/image-loader.gif');

    this.renderer.setStyle(this.el.nativeElement, 'background-image', `url(${ImgLoaderDirective.loaderGifUrl})`);
    this.renderer.addClass(this.el.nativeElement, 'loading');
    // TODO: rogue event listener here?
    this.renderer.listen(this.el.nativeElement, 'load', (evt) => {
      this.renderer.setStyle(this.el.nativeElement, 'background-image', 'initial');
      this.renderer.removeClass(this.el.nativeElement, 'loading');
    });
    this.renderer.listen(this.el.nativeElement, 'error', (evt) => {
      this.renderer.setStyle(this.el.nativeElement, 'background-image', 'initial');
      this.renderer.removeClass(this.el.nativeElement, 'loading');
    });
  }
}
